import { TablePageLayout } from '@kirz/mui-admin';
import React from 'react';

import { ClientFormsTable } from 'components/ClientFormsTable';
import { HideStationSelector } from 'layouts/HideStationSelector';

export function ClientForms() {
  return (
    <HideStationSelector>
      <TablePageLayout title="Formulieren">
        <ClientFormsTable
          id="client-forms-table"
          searchFilter={{
            inputProps: {
              placeholder: 'Zoeken op naam',
            },
            filter: (search) => ({
              _or: search.flatMap((str) => [{ name: { _ilike: `%${str}%` } }]),
            }),
          }}
        />
      </TablePageLayout>
    </HideStationSelector>
  );
}
